module.exports = __webpack_public_path__ + "static/media/info.d0ffa763.svg";